import { useEffect, useState, useCallback } from "react";

const KEY = "organo_wishlist_v1";

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

export default function useWishlist() {
  const [ids, setIds] = useState(read);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(ids));
  }, [ids]);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === KEY) setIds(read());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const toggle = useCallback((id) => {
    setIds((curr) => (curr.includes(id) ? curr.filter((x) => x !== id) : [...curr, id]));
  }, []);

  const has = useCallback((id) => ids.includes(id), [ids]);
  const clear = useCallback(() => setIds([]), []);

  return { ids, toggle, has, clear, count: ids.length };
}
